import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';

export const Header = styled.div`
    display: flex;
    align-items: center;
    //  background: #f5f5f5 0% 0% no-repeat padding-box;
    background: #ebebeb 0% 0% no-repeat padding-box;
    margin-top: 20px;
    padding: 6px 0;
    /* padding-top: 10px;
    padding-bottom: 25px; */
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '20px')};
    width: ${({ width }) => (width ? width : '100%')};
    height: ${({ height }) => (height ? height : '38px')};
    text-align: left;
    //font:15px Avenir Next World;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    font-family: ${FONT_FAMILY_DEMI} ;
    font-size: 13px;
    color: #5f5f5f;

    ${media.mobileDevice`
        margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '10px')};
        margin-bottom: ${({ mbMarginBottom }) =>
            mbMarginBottom ? mbMarginBottom : '0'};
        /* padding-bottom: 30px; */
        padding: ${({ mobilePadding }) =>
            mobilePadding ? mobilePadding : '10px 0'};
        // extra space removed b/w tissue service label and shipping details
        // grey color applied from edge to edge
        height: ${({ mbHeight }) => mbHeight ? mbHeight : '33px'};
        
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : 'calc(100%)')};
        margin-left:${({ marginLeft }) => marginLeft && marginLeft};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '20px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
        align-items: center ;
        background-color: ${({ mbBackGroundColor }) =>
            mbBackGroundColor ? mbBackGroundColor : '#EBEDED'};
    `};
`;